const Logo = () => {
  return (
    <div className="flex h-24 w-36 shrink-0 items-center">
      <img src="/cwap/Logotypes/Logotype_White_PACTSWAP.svg" alt="logo" />
    </div>
  );
};

export default Logo;
